import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

const GoogleSignInButton = ({ clientId, onSuccess, onError, disabled }) => {
  if (!clientId) return null;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div className="sso-buttons">
        <GoogleLogin
          onSuccess={(credentialResponse) => {
            if (credentialResponse.credential) {
              onSuccess(credentialResponse.credential);
            }
          }}
          onError={() => {
            if (onError) onError('Google sign-in failed');
          }}
          useOneTap={false}
          type="standard"
          theme="outline"
          size="large"
          width="100%"
          text="continue_with"
          disabled={disabled}
        />
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleSignInButton;
